export default __webpack_public_path__ + "static/media/1009.64a34034.png";